import { PIPELINE } from "../constants";

const {
  PIPELINE_SWIMLANES,
  BY_ACCOUNT,
  BY_OWNER,
  BY_DATE,
  BY_ALPHABETICAL,
  BY_LAST_UPDATE,
  BY_DATE_CREATED,
  BY_STAGES,
} = PIPELINE;

// function sortByKey(array, key, sortOrderAscending) {
//   return array.sort((a, b) => {
//     const x = a[key];
//     const y = b[key];
//     return sortOrderAscending
//       ? x < y
//         ? -1
//         : x > y
//         ? 1
//         : 0
//       : x > y
//       ? -1
//       : x < y
//       ? 1
//       : 0;
//   });
// }

// function sortByKeyNumber(array, key, sortOrderAscending) {
//   return array.sort((a, b) => {
//     const x = a[key];
//     const y = b[key];
//     // var x = parseInt(a[key], 10);
//     // var y = parseInt(b[key], 10);
//     return sortOrderAscending ? x - y : y - x;
//   });
// }

// export const opportunitySort = (
//   opportunities,
//   sortOption,
//   sortOrderAscending,
// ) => {
//   const key = Object.keys(opportunitiesHeadersMap).find(
//     key => key === sortOption,
//   );
//   console.debug(key);
//   const type = opportunitiesHeadersMap[key].type;
//   if (type === "number") {
//     sortByKeyNumber(
//       opportunities,
//       opportunitiesHeadersMap[key].value,
//       sortOrderAscending,
//     );
//   }
//   return sortByKey(
//     opportunities,
//     opportunitiesHeadersMap[key].value,
//     sortOrderAscending,
//   );
// };

// export const prepareSortOptionsFromOpportunities = () =>
//   Object.keys(opportunitiesHeadersMap).map(item => {
//     const sortOptionObj = {};
//     sortOptionObj.value = item;
//     sortOptionObj.label = item;
//     return sortOptionObj;
//   });

// export const prepareAccountFilterOptionsFromOpportunities = opportunities => {
//   const options = opportunities.map(
//     opportunity => opportunity.crm_account.name,
//   );
//   let uniqueOptions = uniq(options);
//   uniqueOptions = uniqueOptions.map(option => {
//     const optionObj = {};
//     optionObj.value = option;
//     optionObj.label = option;
//     return optionObj;
//   });
//   const allAccountsOption = {};
//   allAccountsOption.value = "All Accounts";
//   allAccountsOption.label = "All Accounts";
//   uniqueOptions = [allAccountsOption, ...uniqueOptions];
//   return uniqueOptions;
// };

// export const getNumOfQuotesInOpportunity = quotes => {
//   if (quotes === null) {
//     return 0;
//   }
//   return quotes.lenght;
// };

// make the url for filtering pipeline opportunnities
export const prepareFilteredOpportunitiesUrl = (
  filters,
  opportunitiesApiUrl,
) => {
  if (filters.length === 0) {
    return opportunitiesApiUrl;
  }
  let url = `${opportunitiesApiUrl}?`;
  let dateFilter;
  let stageFilter;

  filters.forEach(filter => {
    // filter by account
    if (filter.name === BY_ACCOUNT) {
      let accountQueryString = "";
      accountQueryString += `account=${filter.accountId}&`;
      if (filters.length === 1) {
        url = `${url}${accountQueryString.slice(0, -1)}`;
      } else {
        url = `${url}${accountQueryString}`;
      }
    }

    // filter by owner
    if (filter.name === BY_OWNER) {
      const ownerFilters = filter.owners;
      let ownerQueryString = "";
      ownerFilters.forEach(ownerFilter => {
        ownerQueryString += `owners=${ownerFilter.id}&`;
      });
      if (filters.length === 1) {
        url = `${url}${ownerQueryString.slice(0, -1)}`;
      } else {
        url = `${url}${ownerQueryString}`;
      }
    }

    // filter by date
    if (filter.name === BY_DATE) {
      dateFilter = filter;
      if (filters.length === 1) {
        url = `${url}from_date=${dateFilter.startDate}&to_date=${
          dateFilter.endDate
        }`;
      } else {
        url = `${url}from_date=${dateFilter.startDate}&to_date=${
          dateFilter.endDate
        }&`;
      }
    }

    // filter by opportunity stages
    if (filter.name === BY_STAGES) {
      stageFilter = filter;
      const { stages } = stageFilter;
      for (let index = 0; index < stages.length; index += 1) {
        const element = stages[index];
        if (index !== stages.length - 1) {
          url = `${url}stage_name=${encodeURIComponent(element)}&`;
        } else {
          url = `${url}stage_name=${encodeURIComponent(element)}`;
        }
      }
    }
  });

  return url;
};

export const quickFilterOpportunities = (oppoArray, searchTerm) =>
  oppoArray.filter(oppo => {
    let account = "";
    if (oppo.crm_account && oppo.crm_account.name) {
      account = oppo.crm_account.name;
    }
    return (
      `${oppo.name} ${oppo.primary_quote_no} ${account}`
        .toUpperCase()
        .indexOf(searchTerm.toUpperCase()) >= 0
    );
  });

// export const quickFilterDocuments = (oppoArray, searchTerm) =>
//   oppoArray.filter(
//     oppo =>
//       `${oppo.docs.title} ${oppo.docs.doc_no}`
//         .toUpperCase()
//         .indexOf(searchTerm.toUpperCase()) >= 0,
//   );

export const convertOpportunitiesIntoPipeLineData = oppoArray => {
  let pipelineData = [];
  pipelineData = PIPELINE_SWIMLANES.map(lane => {
    lane.opportunitiesByDocs = [];
    oppoArray.forEach(opportunity => {
      opportunity.docs.forEach(doc => {
        if (doc.status === lane.status) {
          const oppByDoc = { ...opportunity, docs: doc };
          lane.opportunitiesByDocs.push(oppByDoc);
        }
      });
    });
    return lane;
  });
  return pipelineData;
};

export const sortOppsDocs = (opportunities, sortBy, isDoc) => {
  let sortedOpportunities = [];
  if (sortBy === BY_LAST_UPDATE) {
    sortedOpportunities = opportunities.sort(
      (a, b) =>
        new Date(isDoc ? b.docs.updated_at : b.updated_at) -
        new Date(isDoc ? a.docs.updated_at : a.updated_at),
    );
  }
  if (sortBy === BY_DATE_CREATED) {
    sortedOpportunities = opportunities.sort(
      (a, b) =>
        new Date(isDoc ? b.docs.created_at : b.created_at) -
        new Date(isDoc ? a.docs.created_at : a.created_at),
    );
  }
  if (sortBy === BY_ALPHABETICAL) {
    sortedOpportunities = opportunities.sort((a, b) =>
      isDoc
        ? a.docs.title.toUpperCase().localeCompare(b.docs.title.toUpperCase())
        : a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
    );
  }
  return sortedOpportunities;
};

export const sortAccountsByAZ = accounts =>
  accounts.sort((a, b) =>
    a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
  );

// get the class name of document status label
export const getDocStatusClassName = docStatus =>
  `document-${docStatus
    .split("_")
    .join("")
    .toLowerCase()}-status`;

// get the class name of deadline date label
export const decideDeadlineDateClassName = days => {
  if (!Number.isNaN(days)) {
    let calcDays = days;
    if (days >= -1) {
      calcDays = Math.ceil(days);
    } else {
      calcDays = days.toFixed();
    }
    let className = "text-success-color";
    if (calcDays <= 1) {
      className = "text-danger-color";
    }
    if (calcDays > 1 && calcDays <= 5) {
      className = "text-warning-color";
    }
    return className;
  }
  return "";
};

// get the message of deadline date tooltip
export const decideDeadlineDaysCount = days => {
  if (!Number.isNaN(days)) {
    let calcDays = days;
    if (days >= -1) {
      calcDays = Math.ceil(days);
    } else {
      calcDays = days.toFixed();
    }
    const message = "This Document needs to be closed by ";
    if (calcDays < 0) {
      return `${Math.abs(calcDays)} day${
        Math.abs(calcDays) > 1 ? "s" : ""
      } past deadline. This deal is at risk`;
    }
    if (calcDays === 0) {
      return `${message} today`;
    }
    if (calcDays === 1) {
      return `${message} tomorrow`;
    }
    return `${message} ${calcDays} days`;
  }
  return "-";
};



// WEBPACK FOOTER //
// ./src/utils/opportunityUtils.js